const styles = (theme) => ({
  // Styles for the container
  width: "400px",
  flex: "none",
  borderRight: `1px solid ${theme.palette.divider}`,
  padding: 7,
  overflowY: "auto",
  flexGrow: 1,

  "& .MuiIconButton-sizeSmall": {
    padding: "5px",
  },

  "& .MuiButtonBase-root svg": {
    transition: "transform 0.5s linear",
    width: 20,
    height: 20,
  },
});

export default styles;
